module.exports = __webpack_public_path__ + "static/media/xcKSM.76662dcd.png";